import React from "react";
import { createChatBotMessage } from "react-chatbot-kit";
import BotAvatar from "./BotAvatar";
import UserAvatar from "./UserAvatar";
import Options from "./Options";
import SupportRes from "./OptionRes/SupportRes";
import PricingRes from "./OptionRes/PricingRes";
import ContactRes from "./OptionRes/ContactRes";

const config = {
  botName: "Money Manager",
  customStyles: {
    botMessageBox: {
      backgroundColor: "rgb(58, 170, 53)",
    },
    chatButton: {
      backgroundColor: "rgb(58, 170, 53)",
    },
  },
  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />,
    userAvatar: (props) => <UserAvatar {...props} />,
  },
  initialMessages: [
    createChatBotMessage(`Hi, I am MoneyBot how can i help you.`, {
      widget: "options",
    }),
  ],
  widgets: [
    {
      widgetName: "options",
      widgetFunc: (props) => <Options {...props} />,
    },
    {
      widgetName: "support",
      widgetFunc: (props) => <SupportRes {...props} />,
    },
    {
      widgetName: "pricing",
      widgetFunc: (props) => <PricingRes {...props} />,
    },
    {
      widgetName: "contact",
      widgetFunc: (props) => <ContactRes {...props} />,
    },
  ],
};

export default config;
